import React from "react";
import {
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  createStyles,
  makeStyles,
  Theme,
} from "@material-ui/core";
import { DateTypeSelect } from "./DateTypeSelect";

/** スタイル定義 */
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: "flex",
      flexDirection: "column",
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    menuItem: {
      // fontSize: "0.875rem",
    },
  })
);

interface Props {
  dateType: string;
  handleDateTypeChange: (event: React.ChangeEvent<{ value: unknown }>) => void;
  dateValue: string;
  handleDateValueChange: (event: React.ChangeEvent<{ value: unknown }>) => void;
}

/**
 * 日付範囲選択
 *
 * Simple Select
 * https://material-ui.com/components/selects/#simple-select
 */
export function DateRangeSelect(props: Props) {
  const classes = useStyles();

  //------------------------------
  // 日付種類
  // [State]
  const { dateType } = props;
  // [Handler]
  const { handleDateTypeChange } = props;

  //------------------------------
  // 日付範囲
  // [State]
  const { dateValue } = props;
  // [Handler]
  const { handleDateValueChange } = props;

  //--------------------
  // コンポーネント
  return (
    <div className={classes.container}>
      <DateTypeSelect
        dateType={dateType}
        handleDateTypeChange={handleDateTypeChange}
      />
      <div>
        <FormControl className={classes.formControl}>
          <InputLabel id="id_date_value_label">日付範囲</InputLabel>
          <Select
            // margin="dense"
            labelId="id_date_value_label"
            id="id_date_value"
            value={dateValue}
            onChange={handleDateValueChange}
            // style={{ fontSize: "0.875rem" }}
          >
            <MenuItem className={classes.menuItem} value="">
              ------
            </MenuItem>
            <MenuItem className={classes.menuItem} value="11">
              １週間以内
            </MenuItem>
            <MenuItem className={classes.menuItem} value="12">
              １か月以内
            </MenuItem>
            <MenuItem className={classes.menuItem} value="13">
              ３か月以内
            </MenuItem>
            <MenuItem className={classes.menuItem} value="14">
              １年以内
            </MenuItem>
          </Select>
        </FormControl>
      </div>
    </div>
  );
}
